import { MEMBERSHIP_BASE_URL } from 'Frontend/constants/endpoint'
import { IRegisterUserForm, IUserApplication } from '../models/user.model'
import { ISelectOption } from '../models/forums.model'
import { IVerificationObject } from '../models/general.model'

export async function createMemberApplication(
    token: string,
    userData: IRegisterUserForm,
): Promise<IVerificationObject> {
    const muncicipalityIdList = userData.municipality?.map((item: ISelectOption) => Number(item.value))
    const competences = userData.competence?.map((item: ISelectOption) => Number(item.value))
    const bodyForumPost = JSON.stringify({
        firstname: userData.firstname,
        lastname: userData.lastname,
        username: userData.username,
        phone: userData.phone,
        mobilePhone: userData.mobilePhone,
        postalAddress: userData.postalCode,
        authority: userData.authority,
        title: userData.title,
        countyId: parseInt(userData.county.value),
        municipalityIds: muncicipalityIdList,
        competenceAreaIds: competences,
        password: userData.password,
        subscribeToNewsletter: userData.subscribeToNewsletter
    })

    let response = await fetch(`${MEMBERSHIP_BASE_URL}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': token,
        },
        body: bodyForumPost,
    })

    const text = await response.text()

    const returnObj: IVerificationObject = {
        status: response.status,
        redirectLink: text,
    }

    return <IVerificationObject>returnObj
}

export async function checkIfUsernameIsValid(token: string, username: string): Promise<boolean> {
    let response = await fetch(`${MEMBERSHIP_BASE_URL}/isusernamevalid?username=${username}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': token,
        },
    })
    const isValid = await response.json()
    return <boolean>isValid
}

export async function checkIfUsernameIsAvailable(token: string, username: string): Promise<boolean> {
    let response = await fetch(`${MEMBERSHIP_BASE_URL}/isusernameavailable?username=${username}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': token,
        },
    })
    const isAvailable = await response.json()
    return <boolean>isAvailable
}

export async function checkIfPasswordIsValid(token: string, password: string): Promise<boolean> {
    let response = await fetch(`${MEMBERSHIP_BASE_URL}/ispasswordvalid?password=${password}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': token,
        },
    })
    const isValid = await response.json()
    return <boolean>isValid
}

export async function getMemberApplications(): Promise<IUserApplication[]> {
    let response = await fetch(`${MEMBERSHIP_BASE_URL}`)

    const jsonResults = await response.json()
    return <IUserApplication[]>jsonResults
}

export async function approveMemberApplication(token: string, applicantId: number): Promise<Boolean> {
    await fetch(`${MEMBERSHIP_BASE_URL}/${applicantId}/approve`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': token,
        },
    })
    return true
}

export async function deleteUserApplication(token: string, applicantId: number): Promise<Boolean> {
    await fetch(`${MEMBERSHIP_BASE_URL}/${applicantId}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': token,
        },
    })
    return true
}
